import {deleteUser, UserDataType, UsersUpdateType, useUpdateAccountUsers} from "@twigsby/client-data";
import {Button, ColourSolid, Modal, ModalType} from "@twigsby/frontend-framework";
import {useState} from "react";
import {useTranslation} from "@twigsby/frontend-framework";

interface ConfirmDeleteUserType extends ModalType {
    user: UserDataType
}

const ConfirmDeleteUserModal = (props: ConfirmDeleteUserType) => {
    const { t } = useTranslation();
    const updateUsers = useUpdateAccountUsers();
    const [deletingUser, setDeletingUser] = useState<boolean>(false);

    const HandleDelete = async (userId: number) => {
        if(userId === -1) return;

        setDeletingUser(true);

        await deleteUser(userId).then((r) => {
            updateUsers.mutate({
                updateType: UsersUpdateType.REMOVE,
                newData: userId,
            });

            props.closeCallback();
        }).catch((e) => {
            console.error(e.response.data);
        }).finally(() => setDeletingUser(false))
    }

    return (
        <Modal title={t('actions.deleteItem', { item: props.user?.name })} isOpen={props.isOpen} closeCallback={() => props.closeCallback()}>
            <p>{t('messages.deleteConfirm')}</p>
            <Button
                title={t('actions.delete')}
                loading={deletingUser}
                colour={ColourSolid.Alert}
                fullWidth={true}
                onClick={() => HandleDelete(props.user?.userId ?? -1)}
            />
        </Modal>
    )
}

export default ConfirmDeleteUserModal
